<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex>
        <h2 class="dark--text font-weight-bold">Articles</h2>
      </v-flex>
      <v-spacer></v-spacer>

      <AddArticle />

      <!-- <app-faq-form v-if="hasRole(AdminUserPermissions.FAQ_ADD)"></app-faq-form> -->
    </v-layout>
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:item.headingEn="{ item }">
        <span v-if="item.headingEn">{{ item.headingEn }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.headingAr="{ item }">
        <span v-if="item.headingAr">{{ item.headingAr }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-icon v-show="item.isActive" color="primary">mdi-checkbox-marked</v-icon>
        <v-icon v-show="!item.isActive" color="grey">mdi-checkbox-blank-outline</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <UpdateArticle :dataInfo="item" />
          <DeleteArticle :data="item" />
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import UpdateArticle from "../components/UpdateArticle.vue";
import AddArticle from "../components/AddArticle.vue";
import DeleteArticle from "../components/DeleteArticle.vue";
export default {
  components: {
    UpdateArticle,
    AddArticle,
    DeleteArticle,
  },
  methods: {},
  data: () => ({
    loading: true,
    articleDetails: [],
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 90,
      },

      {
        text: "Heading (English)",
        value: "headingEn",
        width: 150,
        sortable: false,
      },
      {
        text: "Heading (Arabic)",
        value: "headingAr",
        width: 150,
        sortable: false,
      },
      {
        text: "Show Order",
        value: "showOrder",
        width: 150,
        sortable: false,
      },
      { text: "Is Active", value: "isActive", sortable: false, width: 120 },

      { text: "Action", value: "actions", sortable: false, width: 90 },
    ],
  }),
  apollo: {
    getArticle() {
      // console.log("djfd");
      return {
        query: require("../api/getArticle.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.articleDetails = data.getArticle.article;
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      console.log(this.articleDetails);
      if (this.articleDetails == null) return [];
      return this.articleDetails.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  created() {
    // if (!this.hasRole(this.AdminUserPermissions.FAQ_VIEW)) {
    //   this.$router.push({
    //     name: "Error404",
    //   });
    // }
  },
  mounted() {
    this.$root.$on("updateArticle", () => {
      this.$apollo.queries.getArticle.refetch();
    });
  },
};
</script>
